export default "__VITE_ASSET__DEI0YMyM__"